import {Component, EventEmitter, Input, OnChanges} from '@angular/core';
import {NgForm} from '@angular/forms';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {BaseModule} from '../../helpers/base-module';
import {StudentService} from '../../services/student.service';
import {Level, ToastService} from '../../services/toast.service';
import {AppropriateInstructionDto} from '@sidr/dto-types';

@Component({
  selector: 'app-student-appropriate-instruction',
  templateUrl: './student-appropriate-instruction.component.html',
  styleUrls: ['./student-appropriate-instruction.component.scss']
})
export class StudentAppropriateInstructionComponent implements OnChanges, BaseModule {

  saving: EventEmitter<boolean>;
  loading: EventEmitter<boolean>;
  displayName = 'Appropriate Instruction';
  moduleName = 'apprinst';
  model: AppropriateInstructionDto;
  oldModel?: AppropriateInstructionDto;

  displayLegacy: boolean;

  @Input() districtId: string;
  @Input() studentId: string;
  @Input() printOptions: PrintOptions;

  constructor(private studentService: StudentService, private toastService: ToastService) {
    this.saving = new EventEmitter<boolean>();
    this.loading = new EventEmitter<boolean>();
    this.model = {
      attended_eightyfive: false,
      curriculum_based: false,
      curriculum_fidelity: false,
      highly_qualified: false,
      teacher_trained: false,
      id: '',
      version: 2
    };
    this.oldModel = undefined;
    this.displayLegacy = false;
  }

  toggleLegacy() {
    this.displayLegacy = !this.displayLegacy;
  }

  getData() {
    if (!this.districtId && !this.studentId) {
      return;
    }
    this.studentService.getAppropriateInstruction(this.districtId, this.studentId).subscribe(p => {
      this.model = p;
    });
    this.studentService.getAppropriateInstructionLegacy(this.districtId, this.studentId).subscribe(p => {
      this.oldModel = p;
    });
  }


  ngOnChanges() {
    this.getData();
  }

  save(f: NgForm) {
    this.studentService.patchAppropriateInstruction(this.districtId, this.studentId, this.model).subscribe(p => {
      this.model = p;
      this.toastService.AddNotification(Level.SUCCESS, 'Appropriate Instruction', 'Appropriate Instruction saved successfully');
    }, err => {
      this.toastService.AddNotification(Level.ERROR, 'Appropriate Instruction', 'Unable to save, please contact your administrator');
    });
  }
}
